module.exports = __webpack_public_path__ + "media/images/logo/Logo-Moovejob-CMJN-fond-transparent-recrutement-6825fed73a27734333a6233c31f1ee68.png";